import { render, staticRenderFns } from "./AddServer.vue?vue&type=template&id=13448b99&scoped=true&"
import script from "./AddServer.vue?vue&type=script&lang=js&"
export * from "./AddServer.vue?vue&type=script&lang=js&"
import style0 from "./AddServer.vue?vue&type=style&index=0&id=13448b99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13448b99",
  null
  
)

export default component.exports